import { useState } from "react";
import { toast } from "sonner";
import { FileSpreadsheet, Loader2 } from "lucide-react";
import { api, errMsg } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Dialog, DialogContent, DialogDescription, DialogFooter, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";

const year = new Date().getFullYear();

export function AccountingExport() {
  const [open, setOpen] = useState(false);
  const [from, setFrom] = useState(`${year}-01-01`);
  const [to, setTo] = useState(`${year}-12-31`);
  const [status, setStatus] = useState("approved");
  const [type, setType] = useState("facture");
  const [busy, setBusy] = useState(false);
  const download = async () => {
    setBusy(true);
    try {
      const { data, headers } = await api.get("/exports/invoices.xlsx", {
        params: { date_from: from || undefined, date_to: to || undefined, status, doc_type: type }, responseType: "blob",
      });
      const name = /filename="?([^"]+)"?/.exec(headers["content-disposition"] || "")?.[1] || "export_comptable.xlsx";
      const url = URL.createObjectURL(data);
      const a = document.createElement("a"); a.href = url; a.download = name; a.click();
      setTimeout(() => URL.revokeObjectURL(url), 2000);
      toast.success("Export Excel téléchargé"); setOpen(false);
    } catch (e) { toast.error(errMsg(e)); } finally { setBusy(false); }
  };
  return (
    <>
      <Button variant="outline" onClick={() => setOpen(true)} data-testid="accounting-export-btn">
        <FileSpreadsheet className="h-4 w-4 mr-2" />Export comptable
      </Button>
      <Dialog open={open} onOpenChange={setOpen}>
        <DialogContent data-testid="accounting-export-dialog">
          <DialogHeader>
            <DialogTitle>Export comptable Excel</DialogTitle>
            <DialogDescription>Fournisseur, n° de facture, date, échéance, HT, TVA, TTC, statut de validation, avec un total et un récapitulatif par fournisseur.</DialogDescription>
          </DialogHeader>
          <div className="grid grid-cols-2 gap-3">
            <label className="text-sm space-y-1"><span className="font-medium">Du</span>
              <Input type="date" value={from} onChange={(e) => setFrom(e.target.value)} data-testid="export-date-from" /></label>
            <label className="text-sm space-y-1"><span className="font-medium">Au</span>
              <Input type="date" value={to} onChange={(e) => setTo(e.target.value)} data-testid="export-date-to" /></label>
            <label className="text-sm space-y-1"><span className="font-medium">Documents</span>
              <Select value={type} onValueChange={setType}>
                <SelectTrigger data-testid="export-type-select"><SelectValue /></SelectTrigger>
                <SelectContent><SelectItem value="facture">Factures</SelectItem><SelectItem value="devis">Devis</SelectItem><SelectItem value="all">Factures et devis</SelectItem></SelectContent>
              </Select></label>
            <label className="text-sm space-y-1"><span className="font-medium">Statut</span>
              <Select value={status} onValueChange={setStatus}>
                <SelectTrigger data-testid="export-status-select"><SelectValue /></SelectTrigger>
                <SelectContent><SelectItem value="approved">Validées uniquement</SelectItem><SelectItem value="all">Toutes</SelectItem></SelectContent>
              </Select></label>
          </div>
          <DialogFooter>
            <Button variant="ghost" onClick={() => setOpen(false)}>Annuler</Button>
            <Button onClick={download} disabled={busy} data-testid="export-download-btn">{busy && <Loader2 className="h-4 w-4 animate-spin mr-2" />}Télécharger l'Excel</Button>
          </DialogFooter>
        </DialogContent>
      </Dialog>
    </>
  );
}
